// tslint:disable-next-line:max-line-length
import { Component, OnDestroy, OnInit, OnChanges, DoCheck, ElementRef, ViewChild, Inject, AfterContentInit, AfterContentChecked, AfterViewChecked } from '@angular/core';
import { Router, ActivatedRoute, Params, RouterLink } from '@angular/router';
import { Subscription, Observable, BehaviorSubject } from 'rxjs';
import { debounceTime } from 'rxjs/operators';
import { DeletePopupComponent } from '../../shared/components/delete-popup/delete-popup.component';
import { MobileNavService } from '../../shared/services/mobile-nav.service';
import { AuthService } from '../../shared/services/auth/auth.service';
import { UtilitiesService } from '../../shared/services/utilities.service';
import { StaticValueService } from '../../shared/services/static-value.service';
import { AssociateService } from '../shared/services/associate.service';
import { FormBuilder, FormGroup, Validators, NgForm } from '@angular/forms';
import { MatSnackBar, MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { DisapprovalComponent } from '../../shared/components/disapproval/disapproval.component';
import { OrganizationService } from '../../shared/services/organization.service';
import { NotificationService } from '../../shared/services/notification.service';
import { ToastService } from '../../shared/services/toast.service'
import { UnarchiveInactivePopupComponent } from '../../shared/components/unarchive-inactive-popup/unarchive-inactive-popup.component';
import { Location } from '@angular/common';
import { Configuration } from '../../app.constants';
import { trigger, state, style, animate, transition } from '@angular/animations';
import { CommonDbService } from '../shared/services/common-db.service';
import { AssessmentsService } from '../../shared/services/assessments.service'
import { UploadFileComponentComponent } from '../../shared/components/upload-file-component/upload-file-component.component';
import { isJsObject } from '@angular/core/src/change_detection/change_detection_util';
import { isString } from '@ng-bootstrap/ng-bootstrap/util/util';
import * as moment_1 from 'moment';
import * as moment from 'moment-timezone';
import { DownloadService } from '../../shared/services/html-png/html-png.service';
import { Sort } from '@angular/material';
import { Ng2ImgToolsService } from 'ng2-img-tools';
import { TrainingService } from '../../shared/services/training.service';
import { isDate } from 'rxjs/internal/util/isDate';

declare let Croppie;
declare let document;

@Component({
    selector: 'app-profile',
    templateUrl: './profile.component.html',
    styleUrls: ['./profile.component.scss'],
    providers: [AssociateService]
})
export class ProfileComponent implements OnDestroy, OnInit, OnChanges {
    public mobilityWishlist: Array<String> = [];
    public keyCounter = 0;
    public typeAheadValidation: Boolean = true;
    public todayDate = new Date();

    public previousCardObject;

    public disapprovalComments: string;
    // orginal managerId's for notifications
    public managerId: string;
    public hrManagerId: string;
    public functionalManagerId: string;
    public fieldChanges = [];

    // drop downs
    public staticDDlist = {};
    public autocompleteAssociate: any;
    // autcomplete Arrays
    public autocompleteAssociateHrManager: any;
    public autocompleteAssociateFunctionalManager: any;
    public autocompleteAssociateLineManager: any;
    public autoCompleteOrganization: any;
    public breadCrumbAction = 'View';
    public tabs = 'personal';

    printInProgress = false;

    public associateId: String;
    public sub: any;
    public show: Boolean = true;
    public isAdmin: Boolean = false;
    public editMode: Boolean = true;
    public publicView: Boolean = false;
    public currentUser: any;
    public canValidate: Boolean = false;
    public canTransfer: Boolean = false;
    public isLineManager: Boolean = false;
    public isHrManager: Boolean = false;
    public isHrExcludingSecondary: Boolean = false;
    public isMyProfile: Boolean = false;
    public tempBase64Img: String = null;
    public tempPdfFile: String = null;
    public action: String;
    public fieldAccessList: any;
    public uploadedFiles = [];
    public tags = ''
    public displayUploadDocs = false;

    public typeAheadHR = true;
    public typeAheadLM = true;
    public typeAheadFM = true;

    public serverApiUrl;

    // Card Edit Mode Boolean's
    public personalInformationEdit: Boolean = false;
    // public contactDetailsEdit: Boolean = false;
    public personalContactDetailsEdit: Boolean = false;
    public workContactDetailsEdit: Boolean = false;
    public languageEdit: Boolean = false;
    public mobilityEdit: Boolean = false;
    public careerGoalsEdit: Boolean = false;
    public workExperienceEdit: Boolean = false;
    public qualificationEdit: Boolean = false;
    public trainingsEdit: Boolean = false;
    public nextpositionEdit: Boolean = false;
    public myStrengthEdit: Boolean = false;
    public jobDescriptionEdit: Boolean = false;
    public groupDetailsEdit: Boolean = false;
    public workGroupsEdit = false;
    public contractDetailsEdit = false;

    // Original Object
    public associate: any;

    // Card Edit Clones
    public formalEducation: any;
    public qualificationsAndTrainings: any;
    public workExperience: any;
    public personalInformation: any;
    public contactDetails: any;
    public personalContactDetails: any;
    public workContactDetails: any;
    public languages: any;
    public mobilityPreference: any;
    public careerGoals: any;
    public jobDescription: any;
    public groupDetails: any;
    public contractDetails: any;
    public groupId: any;
    public localId: any;
    public workGroupsAndCommittees: any;
    public errors: any;
    public organizations: any;
    public nextPositions: any;
    public myStrength: any;
    public isProxyUser: Boolean = false;
    // arrays for showing information about previous value
    public removedWorkExperience = [];
    public addedWorkExperience = [];
    public updatedWorkExperience = [];
    public removedEducation = [];
    public addedEducation = [];
    public updatedEducation = [];
    public managementTabData: any;
    public isMyLineManager = false;

    // testing text-mask
    public mask;

    // sites
    public sites = [];
    public selectedSite;
    public trainingsData: any;
    public managementGraphicalHeirarchyQuery;
    public managementHeirarchyisGraphicalOrTabular: String = 'tabular';
    allTrainings: any;
    public soneparCountries;
    public validatedQualificationsAndTrainings: any;


    trainings: any;
    public removedTrainings = [];
    public addedTrainings = [];
    public updatedTrainings = [];

    public hrManagerSearchBeh = new BehaviorSubject<String>('');
    public hrManagerSearchObs = this.hrManagerSearchBeh.asObservable();
    public functionalManagerSearchBeh = new BehaviorSubject<String>('');
    public functionalManagerSearchObs = this.functionalManagerSearchBeh.asObservable();
    public lineManagerSearchBeh = new BehaviorSubject<String>('');
    public lineManagerSearchObs = this.lineManagerSearchBeh.asObservable();


    //@alihaider-plans↓↓
    assessments = [];
    selectedAssessId = 2018;
    isHistoryViewable = false;
    successorValues = {};
    developmentValues = [];
    myPurpose = 'validation';
    currentPlansTab = 'summary'; // open summary tab by default
    isPlanned = true;
    //@alihaider-plans↑↑

    public childFormValidCheck: Boolean = true;
    public isNewWorkExpAdded: Boolean = false;
    public isNewEduAdded: Boolean = false;
    public isNewTrainingAdded: Boolean = false;

    constructor(public route: ActivatedRoute,
        public utilities: UtilitiesService,
        public dialog: MatDialog,
        public mobileNav: MobileNavService,
        public htmlPngService: DownloadService,
        public auth: AuthService,
        public assc: AssociateService,
        public staticDataService: StaticValueService,
        public snackBar: MatSnackBar,
        public router: Router,
        public AssessmentsServiceObj: AssessmentsService,
        private ng2ImgToolsService: Ng2ImgToolsService,
        public organizationService: OrganizationService,
        public toastService: ToastService,
        public notificationService: NotificationService,
        public matsnackBar: MatSnackBar,
        public _location: Location,
        public config: Configuration,
        public commonDbService: CommonDbService,
        public trainingService: TrainingService,
    ) {

        this.currentUser = this.auth.user;
    }

    ngOnDestroy() {
    }

    // open dialog for archive
    openDialog(field: string): void {
        const dialogRef = this.dialog.open(DeletePopupComponent, {
            width: '400px',
            data: { name: 'Associate' }
        });
        dialogRef.afterClosed().subscribe(result => {
            if (result === 'Cancel') {
            } else if (result === 'Proceed') {
                if (field === 'archive') {
                    this.archive();
                } else if (field === 'unArchive') {
                    this.unArchive();
                } else if (field === 'inactive') {
                    this.markInactive('Inactive');
                } else if (field === 'active') {
                    this.markInactive('active');
                }
            }
        });
    }

    ngOnChanges() { }

    eighteenyearsValidation(date) {
        if (date) {
            var oneDay = 24 * 60 * 60 * 1000; // hours*minutes*seconds*milliseconds
            var firstDate = new Date(date);
            var secondDate = new Date();
            var diffDays = Math.round(Math.abs((firstDate.getTime() - secondDate.getTime()) / (oneDay)));
            var isNewPosition = false;
            if (diffDays < 6588) {
                return false;
            } else {
                return true;
            }
        }
        else {
            return true;
        }
    }

    checkDiffOfDateAndDOB(date, dob) {
        var startDate = moment(dob);
        var endDate = moment(date);

        return this.utilities.isDateDiffLessThanDuration(endDate, startDate, 18);
    }

    assignCardObjects() {
        // set selected SIte to incoming site
        this.selectedSite = JSON.parse(JSON.stringify(this.associate.workContactDetails.site));
        // setting timezone independent dates
        if (this.associate.personalInformation.dateOfBirth) {
            this.associate.personalInformation.dateOfBirth = moment
                .parseZone(this.associate.personalInformation.dateOfBirth, 'YYYY-MM-DD').zone(0).format();
        }
        if (this.associate.jobDescription.jobStartDate) {
            this.associate.jobDescription.jobStartDate = moment
                .parseZone(this.associate.jobDescription.jobStartDate, 'YYYY-MM-DD').zone(0).format();
        }
        if (this.associate.groupDetails.groupJoinDate) {
            this.associate.groupDetails.groupJoinDate = moment
                .parseZone(this.associate.groupDetails.groupJoinDate, 'YYYY-MM-DD').zone(0).format();
        }
        if (this.associate.contractDetails.contractStartDate) {
            this.associate.contractDetails.contractStartDate = moment
                .parseZone(this.associate.contractDetails.contractStartDate, 'YYYY-MM-DD').zone(0).format();
        }
        if (this.associate.contractDetails.contractEndDate) {
            this.associate.contractDetails.contractEndDate = moment
                .parseZone(this.associate.contractDetails.contractEndDate, 'YYYY-MM-DD').zone(0).format();
        }
        // -------------------------------------------
        this.personalInformation = JSON.parse(JSON.stringify(this.associate['personalInformation']));
        this.personalContactDetails = JSON.parse(JSON.stringify(this.associate['personalContactDetails']));
        this.workContactDetails = JSON.parse(JSON.stringify(this.associate['workContactDetails']));
        this.languages = JSON.parse(JSON.stringify(this.associate['languages']));
        this.mobilityPreference = JSON.parse(JSON.stringify(this.associate['mobilityPreference']));
        this.careerGoals = JSON.parse(JSON.stringify(this.associate['careerGoals']));
        this.workExperience = JSON.parse(JSON.stringify(this.associate['workExperience']));
        this.formalEducation = JSON.parse(JSON.stringify(this.associate['qualificationsAndTrainings']['formalEducation']));
        this.qualificationsAndTrainings = JSON.parse(JSON.stringify(this.associate['qualificationsAndTrainings']));
        this.workGroupsAndCommittees = Object.assign([], this.associate['workGroupsAndCommittees']);
        this.jobDescription = JSON.parse(JSON.stringify(this.associate['jobDescription']));
        this.groupDetails = JSON.parse(JSON.stringify(this.associate['groupDetails']));
        this.contractDetails = JSON.parse(JSON.stringify(this.associate['contractDetails']));
        this.nextPositions = JSON.parse(JSON.stringify(this.associate['nextPositions']));
        this.myStrength = this.associate['myStrength'] ? this.associate['myStrength'].strengths.join() : '';
        this.localId = this.associate.localId;
        this.groupId = this.associate.groupId;
        this.managerId = this.jobDescription.manager.id;
        this.functionalManagerId = this.jobDescription.functionalManager.id;
        this.hrManagerId = this.jobDescription.hrManager.id;
        this.tabs = 'personal';
        // build query object for graphical heirarchy
        this.managementGraphicalHeirarchyQuery = {
            'associateId': this.associate._id,
            'functionalManagerId': this.associate.jobDescription.functionalManager.id,
            'lineManagerId': this.associate.jobDescription.manager.id
        }

        this.trainings = JSON.parse(JSON.stringify(this.associate['trainings']));
    }

    managementTabInfo(associateId) {
        this.assc.managementTabInfo(associateId).subscribe(data => {
            this.managementTabData = data;
            if (this.managementTabData && this.managementTabData.dreportingLineAssociates) {
                this.managementTabData.dreportingLineAssociates.forEach(indAssoc => {
                    if (indAssoc._id.toString() === this.auth.user.associateId.toString()) {
                        this.isMyLineManager = true;
                    }
                });
            }
        }, error => { });
    }

    //@alihaider-plans↓↓
    getDefaultAssessment() {
        if (this.assessments.length) {
            this.selectedAssessId = this.assessments[this.assessments.length - 1].assessmentId;
            if (this.isAssessAssessed(this.selectedAssessId)) {
                this.getAssessData(this.selectedAssessId);
                this.isHistoryViewable = true;
            } else {
                this.isHistoryViewable = false;
            }
        } else {
            this.isHistoryViewable = false;
        }
    }

    yearChanged() {
        console.log("coming here")
        if (this.isAssessAssessed(this.selectedAssessId)) {
            console.log("coming here 2" )

            this.getAssessData(this.selectedAssessId);
            this.isHistoryViewable = true;
        } else {
            console.log("coming here 3")

            this.isHistoryViewable = false;
        }
    }

    isAssessAssessed(assessId) {
        for (let i = 0; i < this.assessments.length; i++) {
            if (this.assessments[i].assessmentId === assessId) {
                if (this.assessments[i].line.isPlanned &&
                    this.assessments[i].line.isAssessed &&
                    this.assessments[i].line.isLeadershipDone) {
                    return true;
                } else {
                    return false;
                }
            }
        }
        return false;
    }
    getAssessData(assessId = null) {

        this.successorValues = {};
        this.developmentValues = [];
        this.AssessmentsServiceObj.getAssessQuestions(this.associateId, assessId).then(response => {
            if (response && response['answers'] && response['answers'][0]['line'] && response['answers'][0]['line']['successor']) {
                this.successorValues = response['answers'][0]['line']['successor'];
            }
            if (response && response['answers'] && response['answers'][0]['line'] && response['answers'][0]['line']['development']) {
                this.developmentValues = response['answers'][0]['line']['development'];
            }
            for (let i = 0; i < response['answers'][0].higherManagers.length; i++) {
                if (response['answers'][0].higherManagers[i].isPlanned && response['answers'][0].higherManagers[i].isLeadershipDone) {
                    this.developmentValues = response['answers'][0].higherManagers[i].development;
                    this.successorValues = response['answers'][0].higherManagers[i].successor;
                }
            }
        }).catch(err => {
            console.log(err);
        });
    }

    printPlans() {
        this.printInProgress = true;
        this.AssessmentsServiceObj.printPlans(this.associateId, this.selectedAssessId).then(res => {
            this.downloadFile(res, 'Plans');
            this.printInProgress = false;
        }).catch(err => {
            this.printInProgress = false;
            console.log(err);
        });
    }

    printVisu() {
        this.printInProgress = true;
        this.AssessmentsServiceObj.printVisualization(this.associateId, this.selectedAssessId).then(res => {
            console.log("res = ", res);
            this.downloadFile(res, 'Summary');
            this.printInProgress = false;
        }).catch(err => {
            console.log("err = ", err);
            console.log(err);
            if (err) {
                this.isHistoryViewable = false;
                this.printInProgress = false;

                // this.toastService.error('Record not found');
            }
        });
    }

    downloadFile(data, postFix) {
        this.assessments.forEach(indAssess => {
            if (indAssess.assessmentId === this.selectedAssessId) {
                if (indAssess.year === 2017) {
                    var blob = new Blob([data], { type: 'image/jpeg' });
                    var url = window.URL.createObjectURL(blob);
                    if (postFix === 'Plans') {
                        this.htmlPngService.downloadExcel(this.associate.personalInformation.fullName + '-' + this.associate.groupId + '-' + postFix + '.pdf', 'application/pdf', url);
                    }
                    else {
                        this.htmlPngService.downloadExcel(this.associate.personalInformation.fullName + '-' + this.associate.groupId + '-' + postFix + '.jpeg', 'image/jpeg', url);
                    }
                    // window.open(url);
                } else {
                    var blob = new Blob([data], { type: 'application/pdf' });
                    var url = window.URL.createObjectURL(blob);
                    this.htmlPngService.downloadExcel(this.associate.personalInformation.fullName + '-' + this.associate.groupId + '-' + postFix + '.pdf', 'application/pdf', url);
                    // window.open(url);
                }
            }
        });
    }
    //@alihaider-plans↑↑

    ngOnInit() {
        // handle observables for manager
        this.hrManagerSearchObs.pipe(debounceTime(700)).subscribe(value => {
            if (value) {
                this.managerTyped('hrManager');
            }
        });
        this.lineManagerSearchObs.pipe(debounceTime(700)).subscribe(value => {
            if (value) {
                this.managerTyped('manager');
            }
        });
        this.functionalManagerSearchObs.pipe(debounceTime(700)).subscribe(value => {
            if (value) {
                this.managerTyped('functionalManager');
            }
        });
        //_-------------------------------------_
        this.assc.getDistinctAssociateCountries().subscribe(data => {
            this.soneparCountries = data;
        }, error => { });
        // setting global mask for phone number mask
        this.mask = this.auth.phoneNumberMaskObject;
        this.serverApiUrl = this.config.StaticImageUrl;
        if (this.auth.user.role === 'Admin') {
            this.isAdmin = true;
        }
        this.staticDDlist = this.staticDataService.staticData.staticDD;
        this.errors = this.staticDataService.errors;
        let tempObject = {};

        tempObject = JSON.parse(JSON.stringify(this.route.snapshot.data));
        this.associate = tempObject['associate']['data'][0];
        this.trainingsData = tempObject['associate']['trainings'] ? tempObject['associate']['trainings'] : [];
        // if(tempObject['associate']['sites'])
        // {
        //     this.sites = Object.assign([],tempObject['associate']['sites'][0]['sites']);
        // }
        this.managementTabData = tempObject['management'];
        if (this.managementTabData && this.managementTabData.dreportingLineAssociates) {
            this.managementTabData.dreportingLineAssociates.forEach(indAssoc => {
                if (indAssoc._id.toString() === this.auth.user.associateId.toString()) {
                    this.isMyLineManager = true;
                }
            });
        }
        // this.previousCardObject = JSON.parse(JSON.stringify( this.route.snapshot.data['associate']['lastValidatedCardsObject']));
        if (this.associate['_id'] === this.auth.user.associateId) {
            this.isMyProfile = true;
        }

        this.currentUser = this.auth.user;
        this.fieldAccessList = this.currentUser['clientAcl'].accessControl.associate.profile;
        this.assignCardObjects();
        // -------------------------
        this.organizationService.getOrganization().subscribe((data) => {
            this.organizations = data;
        }, (error) => {
        });

        // all sites
        this.organizationService.getAllSites().subscribe((data) => {
            this.sites = Object.assign([], data['sites']);
            this.selectedSite = JSON.parse(JSON.stringify(this.associate.workContactDetails.site));
            const index = this.sites.map(function (s) { return s._id }).indexOf(this.selectedSite['id']);
            if (index !== -1) {
                this.selectedSite = JSON.parse(JSON.stringify(this.sites[index]));
            }
        }, (error) => {
        });
        // ---------------------------
        this.route.params.subscribe(params => {
            this.associateId = params['id'];


            //@alihaider-plans↓↓
            this.AssessmentsServiceObj.getAssessHistoryIds(this.associateId).then(assessments => {
                this.assessments = assessments['assess'];
                this.getDefaultAssessment();
            }).catch(err => {
                console.log(err);
            });
            //@alihaider-plans↑↑

            this.assc.getAssociate(this.associateId).subscribe((data) => {
                this.associate = JSON.parse(JSON.stringify(data['data'][0]));
                // if (data['sites']) {
                //     this.sites = Object.assign([],data['sites']) ;
                // }
                this.managementTabInfo(this.associate['_id']);
                this.assignCardObjects();
                this.previousCardObject = JSON.parse(JSON.stringify(data['lastValidatedCardsObject']));
                if (this.canValidate) {
                    const tempPrevWE = JSON.parse(JSON.stringify(this.previousCardObject.workExperience.experience));
                    const tempWE = JSON.parse(JSON.stringify(this.workExperience.experience));
                    const updateWorkExperience = [];
                    this.calculatingElementsAddedRemovedRemainingArray(tempPrevWE, tempWE,
                        this.updatedWorkExperience, 'workExperience');
                    // -------------------------------
                    const tempPrevEdu = JSON.parse(JSON.stringify
                        (this.previousCardObject.qualificationsAndTrainings.formalEducation));
                    const tempEdu = JSON.parse(JSON.stringify(this.qualificationsAndTrainings.formalEducation));
                    this.calculatingElementsAddedRemovedRemainingArray(tempPrevEdu, tempEdu,
                        this.updatedEducation, 'Education');
                    // -------------------------------
                    const tempPrevTraining = JSON.parse(JSON.stringify(this.previousCardObject.trainings.ownTraining));
                    const tempTraining = JSON.parse(JSON.stringify(this.trainings.ownTraining));
                    this.calculatingTrainingAddedRemovedRemainingArray(tempTraining, tempPrevTraining);
                }
                this.tabs = params['tab'] ? params['tab'] : this.tabs;
                if (params['card']) {
                    this[params['card']] = true;
                }
            }, (error) => {
            });
            this.action = params['action'];
            if (this.action === 'validate') {
                this.editMode = true;
                this.canValidate = true;
                this.breadCrumbAction = 'Validation';
                if (this.currentUser['associateId'] === this.jobDescription.manager.id) {
                    this.isLineManager = true;
                }
                if (this.currentUser['associateId'] === this.jobDescription.hrManager.id) {
                    this.isHrManager = true;
                    this.isHrExcludingSecondary = true;
                }
                if (this.jobDescription.secondHR.indexOf(this.currentUser['associateId']) !== -1) {
                    this.isHrManager = true;
                }
                for (let l = this.associate.lastEdited; l > 0; l--) {
                }
            } else if (this.action === 'edit') {
                this.editMode = true;
                this.canValidate = false;
                this.breadCrumbAction = 'Edit';
                if (this.currentUser['associateId'] === this.jobDescription.manager.id) {
                    this.isLineManager = true;
                }
                if (this.currentUser['associateId'] === this.jobDescription.hrManager.id) {
                    this.isHrManager = true;
                    this.isHrExcludingSecondary = true;
                }
                if (this.jobDescription.secondHR.indexOf(this.currentUser['associateId']) !== -1) {
                    this.isHrManager = true;
                }
            } else if (this.action === 'view') {
                this.editMode = false;
                this.canValidate = false;
                this.breadCrumbAction = 'View';
                this.publicView = true;
                if (this.currentUser['associateId'] === this.jobDescription.manager.id) {
                    this.isLineManager = true;
                }
                if (this.currentUser['associateId'] === this.jobDescription.hrManager.id) {
                    this.isHrManager = true;
                    this.isHrExcludingSecondary = true;
                }
                if (this.jobDescription.secondHR.indexOf(this.currentUser['associateId']) !== -1) {
                    this.isHrManager = true;
                }
            } else if (this.action === 'transfer') {
                this.editMode = false;
                this.canValidate = false;
                this.canTransfer = true;
                if (this.currentUser['associateId'] === this.jobDescription.manager.id) {
                    this.isLineManager = true;
                }
                if (this.currentUser['associateId'] === this.jobDescription.hrManager.id) {
                    this.isHrManager = true;
                    this.isHrExcludingSecondary = true;
                }
                if (this.jobDescription.secondHR.indexOf(this.currentUser['associateId']) !== -1) {
                    this.isHrManager = true;
                }
            } else {
                this.isMyProfile = true;
            }
            if (this.canValidate) {
                this.previousCardObject = tempObject['associate']['lastValidatedCardsObject'];
            }
        });

        if (this.auth.user.role !== 'Admin' && this.auth.user.associateId !== this.associate._id && !this.associate.active) {
            this.toastService.error('this associate is archived, please contact Admin/HR for more details');
            this._location.back();
        }

        if (this.associate.myProxyUsers) {
            this.associate.myProxyUsers.forEach(proxy => {
                if (proxy.associateId === this.currentUser['associateId']) {
                    this.isProxyUser = true;
                }
            });
        }

        this.trainingService.getAllCourses({}, { name: 1 }, 0, 50000)
            .subscribe(data => {
                this.allTrainings = data['data'];
            })

        this.getTrainings();

        this.assc.getLastValidatedCard(this.associate._id, 'qualificationsAndTrainings').subscribe(card => {
            this.validatedQualificationsAndTrainings = JSON.parse(JSON.stringify(card));
        }, error => {
        });
    }

    setTimeZone() {
        this.associate.personalInformation.dateOfBirth = moment(this.associate.personalInformation.dateOfBirth, 'YYYY-MM-DD').format();
        this.associate.jobDescription.jobStartDate = moment(this.associate.jobDescription.jobStartDate, 'YYYY-MM-DD').format();
        this.associate.groupDetails.groupJoinDate = moment(this.associate.groupDetails.groupJoinDate, 'YYYY-MM-DD').format();
        this.associate.contractDetails.contractEndDate = moment(this.associate.contractDetails.contractEndDate, 'YYYY-MM-DD').format();
        this.associate.contractDetails.contractStartDate = moment(this.associate.contractDetails.contractStartDate, 'YYYY-MM-DD').format();
        for (let i = 0; i < this.associate.workExperience.experience.length; i++) {
            this.associate.workExperience.experience[i] = moment(this.associate.workExperience.experience[i], 'YYYY-MM-DD').format();
        }
    }
    onFileChange(event, field, index?: number) {
        console.log(" this is event ------- ",event)
        const reader = new FileReader();
        const reader2 = new FileReader();
        if (field === 'image') {
            if (event.target.files && event.target.files.length > 0) {
                const file = event.target.files[0];
                if (event.target.files[0].type === 'image/png' || event.target.files[0].type === 'image/jpg'
                    || event.target.files[0].type === 'image/jpeg') {
                    reader.readAsDataURL(file);
                    reader.onload = (onLoadResult) => {
                        console.log(" this is reader ------- ", reader)
                        this.tempBase64Img = (<string>reader.result);
                        this.associate.avatar = {
                            filename: file.name,
                            filetype: file.type,
                            imageData: (<string>reader.result).split(',')[1]
                        };
                        const imageElem = new Image();
                        imageElem.onload = (imageOnloadResult) => {
                            // if (imageOnloadResult['path'][0]['width'] < 236 && imageOnloadResult['path'][0]['height'] < 272) {
                            //     this.openCropImageDialog(reader.result);
                            // } else {
                            let newWidth = 236;
                            let newHeight = 272;
                            if (imageOnloadResult && imageOnloadResult['path'] && imageOnloadResult['path'][0] && imageOnloadResult['path'][0]['width']) {
                                const curWidth = imageOnloadResult['path'][0]['width'];
                                const curHeight = imageOnloadResult['path'][0]['height'];
                                newWidth = curWidth;
                                newHeight = curHeight;
                                const requiredRatio = 236 / 272;
                                const currentRatio = curWidth / curHeight;
                                if (currentRatio > requiredRatio) {
                                    newHeight = curWidth / requiredRatio;
                                } else {
                                    newWidth = curHeight * requiredRatio;
                                }
                            }
                            // tslint:disable-next-line:max-line-length
                            this.ng2ImgToolsService.resizeExactFillImage(event.target.files[0], newWidth, newHeight, '#ffffff').subscribe(result => {
                                reader2.readAsDataURL(result);
                                reader2.onload = () => {
                                    this.openCropImageDialog(reader2.result);
                                }
                            }, err => {
                                console.log(err);
                            });
                            // }
                        };
                        imageElem.src = onLoadResult['target']['result'];
                    };
                } else {
                    this.toastService.error(this.errors.File['404']);
                }
            }
        } else if (field === 'workExperience' || field === 'formalEducation' || field === 'trainings') {
            if (event.target.files && event.target.files.length > 0) {
                let file = event.target.files[0];
                let originalFileName = file['name'];
                if (event.target.files[0].size < 2000000 && event.target.files[0].type === 'application/pdf') {
                    reader.readAsDataURL(file);
                    reader.onload = () => {
                        this.tempPdfFile = (<string>reader.result).split(',')[1];
                        let name = this.makeId(10);
                        let fileObj = {
                            'filename': name,
                            'filetype': file.type,
                            'fileData': (<string>reader.result).split(',')[1]
                        };
                        this.assc.uploadFile(fileObj).subscribe((data) => {
                            // this.toastService.success();
                        }, (error) => {
                            this.toastService.error(this.errors.Server['501']);
                        });
                        if (field === 'workExperience') {
                            this.workExperience.experience[index].originalDocumentName = originalFileName;
                            this.workExperience.experience[index].experienceLetter = `./uploads/${name}.pdf`;
                        } else if (field === 'formalEducation') {
                            this.qualificationsAndTrainings.formalEducation[index].originalDocumentName = originalFileName;
                            this.qualificationsAndTrainings.formalEducation[index].schoolDocument = `./uploads/${name}.pdf`;
                        } else if (field === 'trainings') {
                            this.trainings.trainings[index].originalDocumentName = originalFileName;
                            this.trainings.trainings[index].trainingDocument = `./uploads/${name}.pdf`;
                        }
                    };
                } else if (event.target.files[0].type !== 'application/pdf') {
                    this.toastService.error(this.errors.File['403']);
                } else if (event.target.files[0].size >= 2000000) {
                    this.toastService.error(this.errors.File['401']);
                }
            }
        }
    }

    archive() {
        this.associate.lastArchivedBy = Object.assign({}, {
            'name': this.auth.user.name,
            'id': this.auth.user.associateId,
            'time': new Date()
        });
        this.associate['lastArchived'].push({
            'name': this.auth.user.name,
            'id': this.auth.user.associateId,
            'time': new Date()
        });
        this.assc.markAsInactive(this.associateId, 'Archive').subscribe((data1) => {
            this.associate.active = false;
            this.assc.updateAssociate(this.associate).subscribe((data2) => {
                this.router.navigate(['../../../home/associate/search']);
                this.snackBar.open('Associate Archived', '', {
                    duration: 3000
                });
                this.associate.workGroupsAndCommittees.filter(group => {
                    this.assc.removeFromWorkgroup(group.workingGroupId, this.associate);
                })
            }, (error) => {
                this.toastService.error(this.errors.Server['501']);
            });
        }, (error) => {

        });
    }

    unArchive() {
        const dialogRef = this.dialog.open(UnarchiveInactivePopupComponent, {
            width: '400px',
            data: { title: 'Unarchive', 'organizations': this.organizations }
        });
        dialogRef.afterClosed().subscribe(result => {
            if (result === 'Cancel') { } else if (result !== 'Cancel') {
                // update company information
                this.associate.jobDescription.company.name = result.organization.company.companyName;
                this.associate.jobDescription.company.id = result.organization._id;
                this.associate.jobDescription.company.displayId = result.organization.company.companyId;
                // updating legal entity
                this.associate.contractDetails.legalEntity.name = result.legalEntity.legalEntityName;
                this.associate.contractDetails.legalEntity.legalEntityId = result.legalEntity._id;
                this.associate.contractDetails.solisCode = result.legalEntity.solisCode;
                // updating site
                this.associate.workContactDetails.site.name = result.site.name;
                this.associate.workContactDetails.site.id = result.site.siteId;
                // update contract End date and Start Date
                this.associate.contractDetails.contractEndDate = result.contractEndDate;
                this.associate.contractDetails.contractStartDate = result.contractStartDate;
                this.assc.unarchiveAssociate(this.associate).subscribe((data) => {
                    this.router.navigate(['../../../home/associate/search']);
                    this.toastService.success();
                }, (error) => {
                    this.toastService.error(this.errors.Server['501']);
                });
            }
        });
    }

    // mark Associate as Inactive
    markInactive(action: string) {
        if (action === 'Inactive') {
            if (this.contractDetails.endOfContractReason !== '') {
                this.assc.markAsInactive(this.associateId, 'Inactive').subscribe((data1) => {
                    this.associate.contractDetails.activeStatus = 'Inactive';
                    this.assc.updateAssociate(this.associate).subscribe((data2) => {
                        this.router.navigate(['../../../home/associate/search']);
                        if (this.associate.role === 'OpCo Manager' || this.associate.role === 'HR Manager') {
                            // send action center notification to admin that associate has been marked Inactive
                            this.notificationService.sendActionMessage('Admin',
                                `${this.personalInformation.givenName} ${this.personalInformation.familyName} has been marked inactive.`,
                                `/home/associate/profile/edit/${this.associate._id}/job/jobDescriptionEdit`, 'Info', 'Associate',
                                '', '', this.associate._id, '', this.fieldChanges, this.associate.personalInformation.avatarUrl);
                        } else if (this.associate.role === 'Line Manager' || this.associate.role === 'Associate'
                            || this.associate.role === 'Marcom Manager' || this.associate.role === 'Admin') {
                            // send action center notification to all managers that associate has been marked Inactive
                            this.notificationService.sendActionMessage(this.associate.jobDescription.hrManager.id,
                                `Your direct report ${this.personalInformation.givenName} ${this.personalInformation.familyName}
                            has been marked inactive.`, `/home/associate/profile/edit/${this.associate._id}/job/jobDescriptionEdit`,
                                'Info', 'Associate', '', '', this.associate._id, '', this.fieldChanges,
                                this.associate.personalInformation.avatarUrl);

                            if (this.jobDescription.secondHR) {
                                for (let i = 0; i < this.jobDescription.secondHR.length; i++) {
                                    this.notificationService.sendActionMessage(this.jobDescription.secondHR[i],
                                        `Your direct report ${this.personalInformation.givenName} ${this.personalInformation.familyName}
                                        has been marked inactive.`, `/home/associate/profile/edit/${this.associate._id}/job/jobDescriptionEdit`, 'Info', 'Associate',
                                        '', '', this.associate._id, '', this.fieldChanges, this.associate.personalInformation.avatarUrl).then(result => { });
                                }
                            }


                            this.notificationService.sendActionMessage(this.associate.jobDescription.manager.id,
                                `${this.personalInformation.givenName} ${this.personalInformation.familyName} has been marked inactive.`,
                                `/home/associate/profile/edit/${this.associate._id}/job/jobDescriptionEdit`, 'Info', 'Associate',
                                '', '', this.associate._id, '', this.fieldChanges, this.associate.personalInformation.avatarUrl);
                            this.notificationService.sendActionMessage(this.associate.jobDescription.functionalManager.id,
                                `${this.personalInformation.givenName} ${this.personalInformation.familyName} has been marked inactive.`,
                                `/home/associate/profile/edit/${this.associate._id}/job/jobDescriptionEdit`, 'Info', 'Associate',
                                '', '', this.associate._id, '', this.fieldChanges, this.associate.personalInformation.avatarUrl);
                        }
                        // remove associate from workgroups
                        this.associate.workGroupsAndCommittees.filter(group => {
                            this.assc.removeFromWorkgroup(group.workingGroupId, this.associate);
                        });
                        this.snackBar.open('Associate marked Inactive', '', {
                            duration: 3000
                        });
                    }, (error) => {
                        this.toastService.error(this.errors.Server['501']);
                    });
                }, (error) => {
                });
                this.assc.updateAssociate(this.associate).subscribe((data) => {
                    this.toastService.success();
                }, (error) => {
                    this.toastService.error(this.errors.Server['501']);
                });
            } else {
                this.toastService.error('End of contract reason" field must be filled to mark associate inactive.');
            }
        } else if (action === 'active') {
            const dialogRef = this.dialog.open(UnarchiveInactivePopupComponent, {
                width: '400px',
                data: { title: 'Reactivate', 'organizations': this.organizations }
            });
            dialogRef.afterClosed().subscribe(result => {
                if (result === 'Cancel') { } else if (result !== 'Cancel') {
                    // update company information
                    this.associate.jobDescription.company.name = result.organization.company.companyName;
                    this.associate.jobDescription.company.id = result.organization._id;
                    this.associate.jobDescription.company.displayId = result.organization.company.companyId;
                    // updating legal entity
                    this.associate.contractDetails.legalEntity.name = result.legalEntity.legalEntityName;
                    this.associate.contractDetails.legalEntity.legalEntityId = result.legalEntity._id;
                    this.associate.contractDetails.solisCode = result.legalEntity.solisCode;
                    // updating site
                    this.associate.workContactDetails.site.name = result.site.name;
                    this.associate.workContactDetails.site.id = result.site.siteId;
                    // update contract End date and Start Date
                    this.associate.contractDetails.contractEndDate = result.contractEndDate;
                    this.associate.contractDetails.contractStartDate = result.contractStartDate;
                    // set contractEndReason Field to empty
                    this.associate.contractDetails.endOfContractReason = '';
                    this.assc.reactivateAssociate(this.associate).subscribe((data) => {
                        this.router.navigate(['../../../home/associate/search']);
                        this.toastService.success();
                    }, (error) => {
                        this.toastService.error(this.errors.Server["501"]);
                    });
                }
            });
        }
    }

    onClickMe() {
        this.mobileNav.showSideNav();
    }
    // adding and removing array element
    addInTrainings() {
        // if (this.qualificationsAndTrainings.formalEducation.length < 5) {
        let fE = {
            'name': '',
            'organization': '',
            'endDate': '',
            'originalDocumentName': '',
            'trainingDocument': '',
            'generatedId': this.makeId(10)
        };
        this.trainings.trainings.push(fE);
        // } else {
        //     this.toastService.error('Only 5 formal Educations can be added.');
        // }
    }

    // adding and removing array element
    addInFormalEducation() {

        var tempArr = [];
        tempArr.push(
            {
                'degreeName': '',
                'institute': '',
                'endDate': '',
                'domain': '',
                'schoolCountry': '',
                'originalDocumentName': '',
                'schoolDocument': '',
                'generatedId': this.makeId(10)
            }
        );
        var newArr = tempArr.concat(this.qualificationsAndTrainings.formalEducation);
        this.qualificationsAndTrainings.formalEducation = JSON.parse(JSON.stringify(newArr))
        this.isNewEduAdded = true;

    }

    addNewTraining() {
        var tempArr = [];
        tempArr.push({});
        var newArr = tempArr.concat(this.trainings.ownTraining);
        this.trainings.ownTraining = JSON.parse(JSON.stringify(newArr))
        this.isNewTrainingAdded = true;
    }

    removeFormalEducation(index: number) {
        this.qualificationsAndTrainings.formalEducation.splice(index, 1);
    }

    removeTraining(index: number) {
        this.trainings.trainings.splice(index, 1);
    }
    addQualificationsAndTrainings() {
        let qnT = { 'name': '', 'organization': '', 'endDate': '' };
        this.qualificationsAndTrainings.push(qnT);
    }

    removeQualificationsAndTrainings(index: number) {
        this.qualificationsAndTrainings.splice(index, 1);
    }

    addPosition() {
        if (this.nextPositions.positions.length < 3) {
            const qnT = { 'role': '', 'organization': '', 'description': '' };
            this.nextPositions.positions.push(qnT);
        } else {
            this.toastService.error('Only 3 Next Positions can be added');
        }
    }
    removePosition(index: number) {
        this.nextPositions.positions.splice(index, 1);
    }

    addWorkExperience() {
        if (this.workExperience.length) {
            if (this.workExperience[this.workExperience.length - 1].duration > 1000) {
                this.toastService.error('Work Experience duration must be in range of 1000');
                return;
            }
        }
        var tempArr = [];
        tempArr.push(
            {
                'designation': '', 'company': '', 'country': '', 'duration': '', 'startDate': '',
                'experienceLetter': '', 'ongoing': '', 'originalDocumentName': '', 'generatedId': this.makeId(10),
                'visibility': 'Public', 'soneparCompany': '', "companyBusinessType": "", 'isStarredJob': this.numberOfStarredWorkExperiences() < 5 ? true : false
            }
        );
        var newArr = tempArr.concat(this.workExperience['experience']);
        this.workExperience['experience'] = JSON.parse(JSON.stringify(newArr))
        this.isNewWorkExpAdded = true;
        // this.workExperience['experience'].unshift(

        // );

    }

    removeWorkExperience(index: number) {
        this.workExperience['experience'].splice(index, 1);
    }

    // ------------------------------------------------------
    // updating individual cards by saving their object and calling update

    setChildValidation(event) {
        this.childFormValidCheck = event;
    }

    save(cardObj: string, editVariable: string, form: NgForm) {
        console.log(" =============================== card obj ", cardObj,"++++", editVariable, " ===== ",form)

        if (cardObj == 'personalContactDetails') {
            if (!form.valid || !this.childFormValidCheck) {
                return
            }
        }
        this.fieldChanges = [];

        // if(cardObj==='trainings'){
        //     this.getTrainings();
        // }
        if (cardObj !== 'ContractDetails') {
            this.assc.getLastValidatedCard(this.associate._id, cardObj).subscribe(card => {
                if (card) {
                    this.detectChanges(card, this[cardObj]);
                } else {
                    this.detectChanges(this.associate[cardObj], this[cardObj]);
                }
                this.saveAndUpdate(cardObj, editVariable, form);
            }, error => {
                this.saveAndUpdate(cardObj, editVariable, form);
            });
        } else {
            this.saveAndUpdate(cardObj, editVariable, form);
        }
    }

    saveAndUpdate(cardObj: string, editVariable: string, form: NgForm) {
        let changes = JSON.parse(JSON.stringify(this.fieldChanges));
        console.log(" this is fieldChanges ++ " , changes)
        let isValidationRequired = this.isValidationRequired(cardObj, changes);
        if (this.personalContactDetails.taxAddressSameAsPersonalAddress) {
            this.personalContactDetails.personalAddress = JSON.parse(JSON.stringify(this.personalContactDetails.taxAddress));
        }
        if (cardObj !== 'mobilityPreference') {
            if (this[cardObj].lastEditedBy) {
                this[cardObj].lastEditedBy.name = this.auth.user.name;
                this[cardObj].lastEditedBy.id = this.auth.user.associateId;
                this[cardObj].lastEditedBy.time = new Date();
            } else if (cardObj === 'myStrength') {
                this.associate['myStrength']["lastEditedBy"] = { name: this.auth.user.name, id: this.auth.user.associateId, time: new Date() }
            }
        }
        if (cardObj === 'mobilityPreference') {
            this.mobilityPreference.forEach((val, index) => {
                if (index == 0) {
                    val.lastEditedBy.name = this.auth.user.name;
                    val.lastEditedBy.id = this.auth.user.associateId;
                    val.lastEditedBy.time = new Date();
                }
            })
        }
        this.associate.localId = this.localId;
        this.associate.groupId = this.groupId;
        if (cardObj === 'workExperience') {
            if (this[cardObj]['experience']) {
                if (this.associate[cardObj]['experience'].length != this[cardObj]['experience'].length &&
                    this.associate[cardObj]['experience'].length < this[cardObj]['experience'].length &&
                    !this.isNewWorkExpAdded) {
                    var lastVal = this[cardObj]['experience'].pop();
                    this[cardObj]['experience'].unshift(lastVal);
                }
                this.associate[cardObj] = JSON.parse(JSON.stringify(this[cardObj]));
                this[cardObj]['validated'] = 2;
                this.associate[cardObj] = JSON.parse(JSON.stringify(this[cardObj]));
                this.isNewWorkExpAdded = false;
            }
        } else if (cardObj === 'qualificationsAndTrainings') {
            if (this[cardObj]['formalEducation']) {
                if (this.associate[cardObj]['formalEducation'].length != this[cardObj]['formalEducation'].length &&
                    this.associate[cardObj]['formalEducation'].length < this[cardObj]['formalEducation'].length &&
                    !this.isNewEduAdded) {
                    var lastVal = this[cardObj]['formalEducation'].pop();
                    this[cardObj]['formalEducation'].unshift(lastVal);
                }
                this.associate[cardObj] = JSON.parse(JSON.stringify(this[cardObj]));
                this[cardObj]['validated'] = 1;
                this.associate[cardObj] = JSON.parse(JSON.stringify(this[cardObj]));
                this.isNewEduAdded = false;
            }
        } else if (cardObj === 'formalEducation') {
            this.associate['qualificationsAndTrainings'].formalEducation = Object.assign([], this[cardObj]);
            this.associate['qualificationsAndTrainings'].validated = 1;
            this.associate['qualificationsAndTrainings'] = JSON.parse(JSON.stringify(this[cardObj]));
        } else if (cardObj === 'groupDetails') {
            this.associate['groupDetails'] = JSON.parse(JSON.stringify(this[cardObj]));
        } else if (cardObj === 'myStrength') {
            this.associate['myStrength'].strengths = this[cardObj].split(',')
        } else if (cardObj === 'trainings') {
            if (this[cardObj]['ownTraining']) {
                if (this.associate[cardObj]['ownTraining'].length != this[cardObj]['ownTraining'].length &&
                    this.associate[cardObj]['ownTraining'].length < this[cardObj]['ownTraining'].length &&
                    !this.isNewTrainingAdded) {
                    var lastVal = this[cardObj]['ownTraining'].pop();
                    this[cardObj]['ownTraining'].unshift(lastVal);
                }
                this.associate[cardObj] = JSON.parse(JSON.stringify(this[cardObj]));
                this[cardObj]['validated'] = 1;
                this.associate[cardObj] = JSON.parse(JSON.stringify(this[cardObj]));
                this.isNewTrainingAdded = false;
            }

        } else {
            this.associate[cardObj] = JSON.parse(JSON.stringify(this[cardObj]));
            if (this.isValidationRequired(cardObj, this.fieldChanges)) {
                this[cardObj]['validated'] = 1;
            }
            this.associate[cardObj] = JSON.parse(JSON.stringify(this[cardObj]));
            if (cardObj === 'mobilityPreference') {
                this.associate['latestMobilityPreference'].willingToRelocate = this[cardObj][0].willingToRelocate;
                this.associate['latestMobilityPreference'].mobilityLocation = this[cardObj][0].mobilityLocation;
                this.associate['latestMobilityPreference'].mobilityChoices = this[cardObj][0].mobilityChoices;
                this.associate['latestMobilityPreference'].mobilityTimeline = this[cardObj][0].mobilityTimeline;
            }
        }
        if (this.isHrManager || this.isAdmin) {
            if (cardObj === 'qualificationsAndTrainings') {
                this.associate['qualificationsAndTrainings'].validated = 2;
                this['qualificationsAndTrainings'].validated = 2
            } else if (cardObj !== 'myStrength') {
                this[cardObj]['validated'] = 2;
                this.associate[cardObj]['validated'] = 2;
            }
        }
        let tempObj = JSON.parse(JSON.stringify(this[cardObj].lastEditedBy ? this[cardObj].lastEditedBy : {}));
        tempObj['cardObj'] = JSON.parse(JSON.stringify({ 'name': cardObj, 'cardObj': this[cardObj] }));
        this.associate.updatedCardName = cardObj;
        // this.associate.lastEdited.push(tempObj);
        this.associateValidation();
        this[editVariable] = false;
        this.update('edit', false, cardObj, null, isValidationRequired); // sending false here just because we need to send the extra optional variable

    }

    personalAddressSameAsTaxAddress(event) {
        this.personalContactDetails.taxAddressSameAsPersonalAddress = event;
    }


    // sets the which it is passed to true
    edit(cardObj: string, editVariable: string, editMode: boolean) {
        this[editVariable] = editMode;
        if (!editMode) {
            if (cardObj === 'workExperience') {
                this[cardObj] = JSON.parse(JSON.stringify(this.associate[cardObj]));
            } else if (cardObj === 'qualificationsAndTrainings') {
                this[cardObj] = JSON.parse(JSON.stringify(this.associate[cardObj]));
            } else if (cardObj === 'formalEducation') {
                this[cardObj] = JSON.parse(JSON.stringify(this.associate['qualificationsAndTrainings']));
            } else {
                if (this.associate.avatar) {
                    this.associate.avatar = null;
                }
                this.tempBase64Img = null;
                this[cardObj] = JSON.parse(JSON.stringify(this.associate[cardObj]));
            }
            this.groupId = this.associate.groupId;
            this.localId = this.associate.localId;
        } else if (cardObj === 'mobilityPreference') {
            // tslint:disable-next-line:max-line-length
            this[cardObj].unshift({
                'willingToRelocate': '',
                'mobilityLocation': '',
                'mobilityChoices': '',
                'mobilityTimeline': 'This Year',
                'date': new Date(),
                'lastEditedBy': {
                    id: '',
                    name: '',
                    time: ''
                }
            });
        } else if (cardObj === 'myStrength') {
            this[cardObj] = this.associate['myStrength'].strengths.join();
        }
    }

    // update associate with mockAssoc object
    update(field: string, validation?: Boolean, cardName?: string, associateCardObj?, sendActionBoolean?) {
        // setting Timezone independent dates
        let associateObjectCopyForUpdating = JSON.parse(JSON.stringify(this.associate));
        if (associateObjectCopyForUpdating.personalInformation.dateOfBirth) {
            associateObjectCopyForUpdating.personalInformation.dateOfBirth = moment(new Date(associateObjectCopyForUpdating.personalInformation.dateOfBirth))
                .format('YYYY-MM-DD');
        }
        if (associateObjectCopyForUpdating.jobDescription.jobStartDate) {
            associateObjectCopyForUpdating.jobDescription.jobStartDate = moment(new Date(associateObjectCopyForUpdating.jobDescription.jobStartDate))
                .format('YYYY-MM-DD');
        }
        if (associateObjectCopyForUpdating.groupDetails.groupJoinDate) {
            associateObjectCopyForUpdating.groupDetails.groupJoinDate = moment(new Date(associateObjectCopyForUpdating.groupDetails.groupJoinDate))
                .format('YYYY-MM-DD');
        }
        if (associateObjectCopyForUpdating.contractDetails.contractStartDate) {
            associateObjectCopyForUpdating.contractDetails.contractStartDate = moment(new Date(associateObjectCopyForUpdating.contractDetails.contractStartDate))
                .format('YYYY-MM-DD');
        }
        if (associateObjectCopyForUpdating.contractDetails.contractEndDate) {
            associateObjectCopyForUpdating.contractDetails.contractEndDate = moment(new Date(associateObjectCopyForUpdating.contractDetails.contractEndDate))
                .format('YYYY-MM-DD');
        }
        // --------------
        if (this.associate.personalInformation.avatarUrl.includes('orange') && cardName === 'personalInformation') {
            if (this[cardName].gender.includes('Female')) {
                this['personalInformation'].avatarUrl = 'uploads/assets/img/profile/Female-orange.png';
            } else {
                this['personalInformation'].avatarUrl = 'uploads/assets/img/profile/Male-orange.png';
            }
        }
        let changes = JSON.parse(JSON.stringify(this.fieldChanges));
        console.log(" ======= associateObjectCopyForUpdating  ", associateObjectCopyForUpdating)
        this.assc.updateAssociate(associateObjectCopyForUpdating).subscribe((data) => {
            if (this.isMyProfile) {
                this.auth.setImageUrl(this.tempBase64Img);
                // this.auth.setImageUrl(this.associate.personalInformation.avatarUrl);
            }
            if (field === 'edit') {
                if (this.isHrManager || this.isAdmin) {
                    // send Notification to associate that his profile has been updated
                    this.notificationService.sendNotification(this.associateId,
                        `Your Profile has been updated by <b>${this.currentUser['name']}</b>`,
                        'Associate', `home/associate/profile/view/${this.associateId}`, this.associate.personalInformation.avatarUrl);
                }
                if (this.isMyProfile && !this.isAdmin) {
                    // send notification in action center to HR for validation
                    let formalEditCardName = this.getFormalCardName(cardName);
                    if (cardName !== 'mobilityPreference' && cardName !== 'careerGoal' && sendActionBoolean) {
                        this.notificationService.sendActionMessage(this.associate.jobDescription.hrManager.id,
                            `Approve ${this.personalInformation.givenName} ${this.personalInformation.familyName}'s profile changes
                            for ${formalEditCardName}`, `/home/associate/profile/validate/${this.associate._id}/${this.tabs}`, 'Validation',
                            'Associate', 2, 0, this.associate._id, cardName, this.fieldChanges, this.associate.personalInformation.avatarUrl)
                            .then(result => {
                            }).catch(error => {
                                console.log('error', error);
                            });

                        // Do not delete in case we need it in the future
                        // if (this.jobDescription.secondHR){
                        //     for (let i=0;i<this.jobDescription.secondHR.length;i++){
                        //         this.notificationService.sendActionMessage(this.jobDescription.secondHR[i],
                        //             `Approve ${this.personalInformation.givenName} ${this.personalInformation.familyName}'s profile changes
                        //             for ${formalEditCardName}`, `/home/associate/profile/validate/${this.associate._id}/${this.tabs}`, 'Validation',
                        //             'Associate', 2, 0, this.associate._id, cardName, this.fieldChanges, this.associate.personalInformation.avatarUrl)
                        //             .then(result => {
                        //             }).catch(error=>{
                        //                 console.log('error',error);
                        //             });
                        //     }
                        // }
                    }
                }

                if (this.hrManagerId !== this.jobDescription.hrManager.id) {
                    // send notification to associate and manager
                    this.notificationService.sendNotification(this.associateId,
                        `Your HR Manager has been changed`, 'Associate', `home/associate/profile/view/${this.associateId}`,
                        this.associate.personalInformation.avatarUrl);
                    this.notificationService.sendNotification(this.jobDescription.hrManager.id,
                        `You have been assigned as HR Manager of <b>${this.personalInformation.givenName} ${this.personalInformation.familyName}</b>`,
                        'Associate', `home/associate/profile/view/${this.associateId}`,
                        this.associate.personalInformation.avatarUrl);
                }
                if (this.functionalManagerId !== this.jobDescription.functionalManager.id) {
                    // send notification to associate and manager
                    this.notificationService.sendNotification(this.associateId,
                        `Your Functional Manager has been changed`, 'Associate', `home/associate/profile/view/${this.associateId}`,
                        this.associate.personalInformation.avatarUrl);
                    this.notificationService.sendNotification(this.jobDescription.hrManager.id,
                        `You have been assigned as Functional Manager of <b>${this.personalInformation.givenName} ${this.personalInformation.familyName}</b>`,
                        'Associate', `home/associate/profile/view/${this.associateId}`,
                        this.associate.personalInformation.avatarUrl);
                }
                if (this.managerId !== this.jobDescription.manager.id) {
                    // send notification to associate and manager
                    this.notificationService.sendNotification(this.associateId,
                        `Your Line Manager has been changed.`, 'Associate', `home/associate/profile/view/${this.associateId}`,
                        this.associate.personalInformation.avatarUrl);
                    this.notificationService.sendNotification(this.jobDescription.functionalManager.id,
                        `You have been assigned as Functional Manager of <b>${this.personalInformation.givenName} ${this.personalInformation.familyName}</b>`,
                        'Associate', `home/associate/profile/view/${this.associateId}`,
                        this.associate.personalInformation.avatarUrl);
                }
            }
            if (field === 'validate') {
                // send notification to associate that profile has been validated
                let formalCardName = this.getFormalCardName(cardName);
                if (validation === true) {
                    this.notificationService.sendNotification(this.associate._id,
                        `Your profile changes for <b>"${formalCardName}"</b> have been approved`,
                        'Associate', `home/associate/profile/view/${this.associateId}`, this.associate.personalInformation.avatarUrl);
                } else {
                    this.notificationService.sendNotification(this.associate._id,
                        `Your profile changes for <b>"${formalCardName}"</b> have been rejected, because: ${this.disapprovalComments}.`,
                        'Associate', `home/associate/profile/view/${this.associateId}`, this.associate.personalInformation.avatarUrl);

                }
            } if (field !== 'none') {
                this.toastService.success();
            }

        }, (error) => {
            this.toastService.error('Unable to edit Associate');
        });
    }



    isValidationRequired(cardObj: string, changes: Array<any>) {
        switch (cardObj) {
            case 'personalInformation': {
                return false;
            }
            case 'personalContactDetails': {
                return false;
            }

            case 'workContactDetails': {
                return changes.length !== 0;
            }

            case 'languages': {
                return false;
            }
            case 'careerGoals': {
                return false;
            }
            case 'qualificationsAndTrainings': {
                return this[cardObj].formalEducation.length !== this.associate[cardObj].formalEducation.length;
            }
            case 'workExperience': {
                return false;
            }
            case 'trainings': {
                // return (this['trainings'].trainings.length !== this.associate['trainings'].trainings.length ||
                //         this['trainings'].ownTraining.length !== this.associate['trainings'].ownTraining.length
                // );
                return this[cardObj].ownTraining.length !== this.associate[cardObj].ownTraining.length;
            }

            case 'jobDescription': {
                if (changes.length === 0) {
                    return false;
                    // } else if (changes.length > 1){
                    //     return true;
                } else {
                    return moment(this.associate['jobDescription'].jobStartDate).format('DD MMM YYYY') !== moment(this.jobDescription.jobStartDate).format('DD MMM YYYY');
                }
            }


            case 'contractDetails': {
                if (changes.length === 0) {
                    return false;
                } else if (changes.length > 0) {
                    return false;
                    //  } else {
                    //      return moment(this.associate['contractDetails'].contractStartDate).format('DD MMM YYYY') !== moment(this.contractDetails.contractStartDate).format('DD MMM YYYY');
                }
            }


            case 'workContactDetails': {
                return changes.length > 0;
            }

            case 'groupDetails': {
                return false;
            }

            case cardObj: {
                return Array.isArray(this[cardObj]) ? this[cardObj].length !== this.associate[cardObj].length : changes.length !== 0;
            }
        }
    }

    validateTrainings(value: Boolean) {
        if (value === false) {
            let dialogRef = this.dialog.open(DisapprovalComponent, {
                width: '500px',
            });
            dialogRef.afterClosed().subscribe(res => {
                if (res) {
                    this.associate.trainings.trainings = JSON.parse(JSON.stringify(this.validatedQualificationsAndTrainings.trainings));
                    this.associate.qualificationsAndTrainings.ownTraining = JSON.parse(JSON.stringify(this.validatedQualificationsAndTrainings.ownTraining));
                    this.trainings.trainings = JSON.parse(JSON.stringify(this.validatedQualificationsAndTrainings.trainings));
                    this.trainings.ownTraining = JSON.parse(JSON.stringify(this.validatedQualificationsAndTrainings.ownTraining));
                    this.associate.updatedCardName = 'qualificationsAndTrainings';
                    this.associateValidation();
                    this.update('validate', value, 'Trainings');
                } else { }
            });
        } else if (value === true) {
            this.associate.trainings.trainings = JSON.parse(JSON.stringify(this.trainings.trainings));
            this.associate.qualificationsAndTrainings.ownTraining = JSON.parse(JSON.stringify(this.trainings.ownTraining));
            this.validatedQualificationsAndTrainings.trainings = JSON.parse(JSON.stringify(this.trainings.trainings));
            this.validatedQualificationsAndTrainings.ownTraining = JSON.parse(JSON.stringify(this.trainings.ownTraining));
            this.associate.updatedCardName = 'qualificationsAndTrainings';
            this.associateValidation();
            this.update('validate', value, 'Trainings');
        }

    }

    validate(name: string, value: boolean) {
        if (value === false) {
            let dialogRef = this.dialog.open(DisapprovalComponent, {
                width: '500px',
            });
            dialogRef.afterClosed().subscribe(res => {
                if (res) {
                    this.disapprovalComments = res;
                    this[name].validated = value ? 2 : 0;
                    this.associate[name] = Object.assign({}, this[name]);
                    // this[name].lastValidatedBy.name = this.auth.user.name;
                    // this[name].lastValidatedBy.id = this.auth.user.associateId;
                    // this[name].lastValidatedBy.time = new Date();
                    // this.associate.updatedCard = name;
                    this.associate.updatedCardName = name;
                    this.associateValidation();
                    this.update('validate', value, name);
                } else { }
            });
        } else {
            this[name].validated = value ? 2 : 0;
            this.associate[name] = Object.assign({}, this[name]);
            // this[name].lastValidatedBy.name = this.auth.user.name;
            // this[name].lastValidatedBy.id = this.auth.user.associateId;
            // this[name].lastValidatedBy.time = new Date();
            // this.associate.updatedCardName = name;
            this.associate.updatedCardName = name;
            this.associateValidation();
            this.update('validate', value, name);
        }
    }

    initialAssociates(search: any) {
        if (this.associate.jobDescription[search].name === '') {
            if (search === 'hrManager') {
                this.assc.getAllAssociatesFilter(search ? search : 'a', 'initial', 'HR Manager').subscribe((data) => {
                    this.autocompleteAssociateHrManager = data;
                }, (error) => { });
            } else if (search === 'manager') {
                this.assc.getAllAssociatesFilter(search ? search : 'a', 'initial', '').subscribe((data) => {
                    this.autocompleteAssociateLineManager = data;
                }, (error) => { });
            } else if (search === 'functionalManager') {
                this.assc.getAllAssociatesFilter(search ? search : 'a', 'initial', '').subscribe((data) => {
                    this.autocompleteAssociateFunctionalManager = data;
                }, (error) => { });
            }
        }
    }
    // initialAssociates(event) {
    //      this.assc.getAllAssociatesFilter(event ? event : 'a', 'initial', '').subscribe((data) => {
    //            this.autocompleteAssociate = data;
    //          }, ( error) => {
    //          });
    //    }
    // managerTyped(fieldName: string) {
    //     this.jobDescription[fieldName].id = '';
    //     this.jobDescription[fieldName].groupId = '';
    //     this.assc.getAllAssociatesFilter(this.jobDescription[fieldName].name, '', '').subscribe((data) => {
    //         this.autocompleteAssociate = data;
    //     }, (error) => {
    //     });
    // }

    managerTyped(fieldName: string) {
        this.keyCounter++;
        this.jobDescription[fieldName].id = '';
        this.jobDescription[fieldName].groupId = '';
        this.typeAheadValidation = false;
        if (fieldName === 'hrManager') {
            this.typeAheadHR = false;
            this.assc.getAllAssociatesFilter(this.jobDescription.hrManager.name, '',
                'HR Manager').subscribe((data) => {
                    this.autocompleteAssociateHrManager = data;
                }, (error) => {
                });
            this.keyCounter = 0;
        } else if (fieldName === 'functionalManager') {
            this.typeAheadFM = false;
            this.assc.getAllAssociatesFilter(this.jobDescription.functionalManager.name, '', '').subscribe((data) => {
                let tempArray = [];
                tempArray = Object.assign([], data);
                this.autocompleteAssociateFunctionalManager = data;
            }, (error) => { });
            this.keyCounter = 0;
        } else if (fieldName === 'manager') {
            this.typeAheadLM = false;
            this.assc.getAllAssociatesFilter(this.jobDescription.manager.name, '',
                '').subscribe((data) => {
                    this.autocompleteAssociateLineManager = data;
                }, (error) => {
                });
            this.keyCounter = 0;
        }
    }
    clickDropDownSite() {
        let sSite = this.sites.find((s) => this.selectedSite.id === s._id);
        this.workContactDetails.site.name = sSite['siteDetails']['siteName'];
        this.workContactDetails.site.id = sSite['_id'];
        this.workContactDetails.site.referenceCity = sSite['siteDetails']['cityOfReference'];
        this.workContactDetails.site.physicalAddress = JSON.parse(JSON.stringify(sSite['siteDetails']['physicalAddress']));
    }

    clickDropDown(recievedAssociate: any, cardObj: string) {
        this.typeAheadValidation = true;
        this.jobDescription[cardObj].name = recievedAssociate.personalInformation.fullName;
        this.jobDescription[cardObj].id = recievedAssociate._id;
        this.jobDescription[cardObj].groupId = recievedAssociate.groupId;
        if (cardObj === 'hrManager') {
            this.typeAheadHR = true;
        } else if (cardObj === 'functionalManager') {
            this.typeAheadFM = true;
        } else if (cardObj === 'manager') {
            this.typeAheadLM = true;
        }
    }
    makeId(size): string {
        let text = '';
        let possible = 'ABCDEFGHJKLMNPQRSTUVWXYZabcdefghijkmnpqrstuvwxyz23456789';
        for (let i = 0; i < size; i++) {
            text += possible.charAt(Math.floor(Math.random() * possible.length));
        }
        return text;
    }

    openCropImageDialog(imageDataEvent): void {
        const dialogRef = this.dialog.open(ImageCropDialogComponent, {
            width: '500px',
            data: { event: imageDataEvent }
        });

        dialogRef.afterClosed().subscribe(result => {
            this.associate.avatar.imageData = result;
            this.tempBase64Img = result;
        });
    }

    // -------------------------------
    associateValidation() {
        if (this.personalInformation.validated === 0 ||
            this.personalContactDetails.validated === 0 || this.workContactDetails.validated === 0 || this.languages.validated === 0 ||
            this.workExperience.validated === 0 || this.qualificationsAndTrainings.validated === 0 || this.trainings.validate === 0) {
            this.associate.validated = 0;
        } else if (this.personalInformation.validated === 1 ||
            this.personalContactDetails.validated === 1 || this.workContactDetails.validated === 1 || this.languages.validated === 1 ||
            this.workExperience.validated === 1 || this.qualificationsAndTrainings.validated === 1 || this.trainings.validate === 1) {
            this.associate.validated = 1;
        } else {
            this.associate.validated = 2;
        }
    }

    tabChange(val: any) {
        this.tabs = val;
        if (val === 'proxy') {
        }
    }

    setVisibility(field: string, index?) {
        if (field === 'civilStatus') {
            if (this.personalInformation.civilStatusVisiblity === 'Private') {
                this.personalInformation.civilStatusVisiblity = 'Public';
                this.associate.personalInformation.civilStatusVisiblity = 'Public';
            } else if (this.personalInformation.civilStatusVisiblity === 'Public') {
                this.personalInformation.civilStatusVisiblity = 'Private';
                this.associate.personalInformation.civilStatusVisiblity = 'Private';
            }
            this.update('none');
        } if (field === 'numberOfChildren') {
            if (this.personalInformation.numberOfChildrenVisiblity === 'Private') {
                this.personalInformation.numberOfChildrenVisiblity = 'Public';
                this.associate.personalInformation.numberOfChildrenVisiblity = 'Public';
            } else if (this.personalInformation.numberOfChildrenVisiblity === 'Public') {
                this.personalInformation.numberOfChildrenVisiblity = 'Private';
                this.associate.personalInformation.numberOfChildrenVisiblity = 'Private';
            }
            this.update('none');
        } if (field === 'dateOfBirth') {
            if (this.personalInformation.dateOfBirthVisiblity === 'Private') {
                this.personalInformation.dateOfBirthVisiblity = 'Public';
                this.associate.personalInformation.dateOfBirthVisiblity = 'Public';
            } else if (this.personalInformation.dateOfBirthVisiblity === 'Public') {
                this.personalInformation.dateOfBirthVisiblity = 'Private';
                this.associate.personalInformation.dateOfBirthVisiblity = 'Private';
            }
            this.update('none');
        } if (field === 'personalEmail') {
            if (this.personalContactDetails.personalEmailVisiblity === 'Private') {
                this.personalContactDetails.personalEmailVisiblity = 'Public';
                this.associate.personalContactDetails.personalEmailVisiblity = 'Public';
            } else if (this.personalContactDetails.personalEmailVisiblity === 'Public') {
                this.personalContactDetails.personalEmailVisiblity = 'Private';
                this.associate.personalContactDetails.personalEmailVisiblity = 'Private';
            }
            this.update('none');
        } if (field === 'personalMobile') {
            if (this.personalContactDetails.personalMobileVisiblity === 'Private') {
                this.personalContactDetails.personalMobileVisiblity = 'Public';
                this.associate.personalContactDetails.personalMobileVisiblity = 'Public';
            } else if (this.personalContactDetails.personalMobileVisiblity === 'Public') {
                this.personalContactDetails.personalMobileVisiblity = 'Private';
                this.associate.personalContactDetails.personalMobileVisiblity = 'Private';
            }
            this.update('none');
        } if (field === 'workExperience') {
            if (this.workExperience['experience'][index].visibility === 'Private') {
                this.workExperience['experience'][index].visibility = 'Public';
                this.associate.workExperience.experience = JSON.parse(JSON.stringify(this.workExperience['experience']));
            } else if (this.workExperience['experience'][index].visibility === 'Public') {
                this.workExperience['experience'][index].visibility = 'Private';
                this.associate.workExperience.experience = JSON.parse(JSON.stringify(this.workExperience['experience']));
            }
            this.update('none');
        }
    }

    swipeTabs(event) {
        if (window.innerWidth < 768) {
            let tabsArray = [];
            let indexLimit = 6;
            if (this.editMode || this.canValidate || this.isHrManager || this.isAdmin || this.isMyProfile ||
                this.auth.user.role === 'OpCo Manager' || this.auth.user.role === 'Line Manager') {
                tabsArray = ['personal', 'job', 'experience', 'education', 'mobility', 'groups', 'management'];
                indexLimit = 6;
            } else {
                tabsArray = ['personal', 'job', 'experience', 'education', 'groups', 'management'];
                indexLimit = 5;
            }
            let currIndex = tabsArray.indexOf(this.tabs);
            if (event === 'swipeleft') {
                currIndex = currIndex + 1;
            } else if (event === 'swiperight') {
                currIndex = currIndex - 1;
            }
            if (currIndex < 0) {
                currIndex = 0;
            } else if (currIndex > indexLimit) {
                currIndex = indexLimit;
            }
            this.tabChange(tabsArray[currIndex]);
            var list = document.getElementById('tabsUl'),
                targetLi = document.getElementById(tabsArray[currIndex]);
            list.scrollLeft = (targetLi.offsetLeft);
            // const config: ScrollToConfigOptions = {
            //     target: tabsArray[currIndex]
            //   };
            //   this._scrollToService.scrollTo(config);
        }
    }
    backBtnClick() {
        this._location.back();
    }

    scrollMobile(event) {
    }

    uploadFilesPopUp(event) {
        const dialogRef = this.dialog.open(UploadFileComponentComponent, {
            width: '350px',
            data: { name: 'Associate' }
        });
        dialogRef.afterClosed().subscribe(res => {
            if (res !== undefined) {
                this.uploadedFiles = res.uploadedFiles;
                this.tags = res.tags;
                this.addFiles();
            }
        }, err => { });

    }

    addFiles() {
        if (!this.uploadedFiles.length) {
            return;
        }
        let counter = 0;
        if (this.uploadedFiles.length > 0) {
            this.uploadedFiles.forEach(file => {
                this.commonDbService.saveFile(file).subscribe(res => {
                    counter++;
                    // tslint:disable-next-line:max-line-length
                    this.associate['documents'].unshift({ fileName: file.filename, tags: this.tags, date: Date(), fileURL: res['imageUrl'] });
                    if (counter === this.uploadedFiles.length) {
                        this.uploadedFiles = [];
                        this.tags = '';
                        this.displayUploadDocs = false;
                        this.assc.updateAssociate(this.associate).subscribe(res => { }, err => {
                        })
                    }
                }, error => { });
            });
        }
    }

    removeHRdocs(index: Number) {
        const dialogRef = this.dialog.open(DeletePopupComponent, {
            width: '400px',
            data: { title: '' }
        });
        dialogRef.afterClosed().subscribe(res => {
            if (res === 'Proceed') {
                this.associate['documents'].splice(index, 1);
                this.assc.updateAssociate(this.associate).subscribe(result => { }, err => {
                })

            }
        });
    }

    calculatingElementsAddedRemovedRemainingArray(orignArrayObjects, newArrayObjects, updateArrayObjects, arrayType) {
        let tempOrignArray = [];
        let tempNewArray = [];
        let tempUpdateArray = [];
        let flag = 0;
        for (let i = orignArrayObjects.length - 1; i >= 0; i--) {
            flag = 0;
            for (let j = newArrayObjects.length - 1; j >= 0; j--) {
                if (orignArrayObjects[i].generatedId === newArrayObjects[j].generatedId) {
                    tempUpdateArray.push(orignArrayObjects[i]);
                    flag = 1;
                    break;
                    // tempOrignArray.splice(i, 1);
                    // tempNewArray.splice(j, 1);
                }
            }
            if (flag === 0) {
                tempOrignArray.push(orignArrayObjects[i]);
            }
        }

        for (let i = newArrayObjects.length - 1; i >= 0; i--) {
            flag = 0;
            for (let j = orignArrayObjects.length - 1; j >= 0; j--) {
                if (orignArrayObjects[j].generatedId === newArrayObjects[i].generatedId) {
                    flag = 1;
                    break;
                    // tempOrignArray.splice(i, 1);
                    // tempNewArray.splice(j, 1);
                }
            }
            if (flag === 0) {
                tempNewArray.push(newArrayObjects[i]);
            }
        }

        if (arrayType === 'workExperience') {
            this.removedWorkExperience = JSON.parse(JSON.stringify(tempOrignArray));
            this.addedWorkExperience = JSON.parse(JSON.stringify(tempNewArray));
            this.updatedWorkExperience = JSON.parse(JSON.stringify(tempUpdateArray));
        } else if (arrayType === 'Education') {
            this.removedEducation = JSON.parse(JSON.stringify(tempOrignArray));
            this.addedEducation = JSON.parse(JSON.stringify(tempNewArray));
            this.updatedEducation = JSON.parse(JSON.stringify(tempUpdateArray));
        } else if (arrayType === 'Training') {
            this.removedTrainings = JSON.parse(JSON.stringify(tempOrignArray));
            this.addedTrainings = JSON.parse(JSON.stringify(tempNewArray));
            this.updatedTrainings = JSON.parse(JSON.stringify(tempUpdateArray));
        }
    }

    calculatingElementsAddedRemovedRemainingArrayEducation(orignArrayObjects, newArrayObjects, updateArrayObjects) {
        for (let i = orignArrayObjects.length - 1; i >= 0; i--) {
            for (let j = newArrayObjects.length - 1; j >= 0; j--) {
                if (orignArrayObjects[i].generatedId === newArrayObjects[j].generatedId) {
                    updateArrayObjects.push(orignArrayObjects[i]);
                    orignArrayObjects.splice(i, 1);
                    newArrayObjects.splice(j, 1);
                }
            }
        }

        // for (let i = 0; i < orignArrayObjects.length; i++) {
        //     for (let j = 0; j < newArrayObjects.length; j++) {
        //         if (orignArrayObjects[i].generatedId === newArrayObjects[j].generatedId) {
        //             updateArrayObjects.push(orignArrayObjects[i]);
        //             orignArrayObjects.splice(i, 1);
        //             newArrayObjects.splice(j, 1);
        //             i = i - 1;
        //             j = j - 1;
        //         }
        //     }
        // }
    }

    calculatingTrainingAddedRemovedRemainingArray(latestObj: Array<any>, validatedObj: Array<any>) {
        latestObj = Object.assign([], latestObj);
        validatedObj = Object.assign([], validatedObj);
        for (let i = 0; i < validatedObj.length; i++) {

            if (latestObj.length === 0) {
                this.removedTrainings.push(validatedObj[i]);
            }

            for (let j = 0; j < latestObj.length; j++) {
                if (this.compareJson(validatedObj[i], latestObj[j])) {
                    this.updatedTrainings.push(validatedObj[i]);
                    latestObj.splice(j, 1);
                    continue;
                } else if (j === latestObj.length - 1) {
                    this.removedTrainings.push(validatedObj[i]);
                }
            }
        }
        this.addedTrainings = latestObj;
    }


    detectChanges(old, new_, parent?) {
        if ((old === new_ && old) || !old) {
            return;
        }
        const properties = Object.keys(old);

        if (Array.isArray(old)) {
            return;
        }
        for (let pr of properties) {
            // tslint:disable-next-line:max-line-length
            // console.log('instance of ',pr,old[pr] instanceof Date, typeof old[pr])
            if (isString(old[pr]) && old[pr] !== new_[pr] && pr !== 'id' && pr !== "activeStatus" && pr !== 'groupId' && pr !== 'validated' && pr !== 'lastValidatedBy' && pr !== 'lastEditedBy' && pr !== 'avatarUrl') {
                // tslint:disable-next-line:max-line-length
                if ((isDate(old[pr]) || new_[pr]) && moment(old[pr]).format('DD MMM YYYY') !== moment(new_[pr]).format('DD MMM YYYY')) {
                    this.fieldChanges.push({ label: this.getFormalCardName(parent) + ' ' + this.getFormalCardName(pr), oldValue: old[pr] ? moment(old[pr]).format('DD MMM YYYY') : '', newValue: new_[pr] ? moment(new_[pr]).format('DD MMM YYYY') : '' });
                } else if (!(isDate(old[pr]) || isDate(new_[pr]))) {
                    this.fieldChanges.push({ label: this.getFormalCardName(parent) + ' ' + this.getFormalCardName(pr), oldValue: old[pr], newValue: new_[pr] });
                }
            } else if (!isString(old[pr]) && pr !== 'validated' && pr !== 'id' && pr !== 'groupId' && pr !== 'lastValidatedBy' && pr !== 'lastEditedBy') {
                this.detectChanges(old[pr], new_[pr], pr);
            } else {
            }
        }
    }


    proxyLogin(associateId) {
        this.auth.proxyLogin(associateId)
            .then(res => {
                const msg = `Dear ${this.associate.personalInformation.fullName},<br>${this.currentUser['name']} logged In from your account as a proxy user`;
                this.notificationService.sendEmail(this.associate.workContactDetails.workEmail, 'Proxy Session info', msg).then().catch();
            }, err => {
            });
    }

    getFormalCardName(cardName: string) {
        switch (cardName) {
            case 'personalInformation': {
                return 'Basic Details'
            }
            case 'workExperience': {
                return 'Work Experience'
            }
            case 'personalContactDetails': {
                return 'Personal Contact Details'
            }
            case 'workContactDetails': {
                return 'Work Contact Details'
            }
            case 'languages': {
                return 'Languages'
            }
            case 'qualificationsAndTrainings': {
                return 'Education'
            }
            case 'careerGoals': {
                return 'Career Goals'
            }
            case 'mobilityPreference': {
                return 'Mobility Preferences'
            }
            case 'jobDescription': {
                return 'Job Description'
            }
            case 'contractDetails': {
                return 'Contract Details'
            }
            case 'localId': {
                return 'Local ID'
            }
            case 'familyName': {
                return 'Family Name'
            }
            case 'givenName': {
                return 'Given Name'
            }
            case 'officialFamilyName': {
                return 'Official Family Name'
            }
            case 'officialGivenName': {
                return 'Official Given Name'
            }
            case 'englishName': {
                return 'English Name'
            }
            case 'dateOfBirth': {
                return 'Date of Birth'
            }
            case 'nationality': {
                return 'Nationality'
            }
            case 'civilStatus': {
                return 'Civil Status'
            }
            case 'gender': {
                return 'Gender'
            }
            case 'workMobile': {
                return 'Work Mobile'
            }
            case 'workCountry': {
                return 'Work Country'
            }
            case 'workEmail': {
                return 'Work Email'
            }
            case 'workLandline': {
                return 'Work Landline'
            }
            case 'emergencyContact': {
                return 'Emergency Contact'
            }
            case 'name': {
                return 'Name'
            }
            case 'contactNumber': {
                return 'Contact Number'
            }
            case 'personalMobile': {
                return 'Personal Mobile'
            }
            case 'personalEmail': {
                return 'Personal Email'
            }
            case 'personalLandline': {
                return 'Personal Landline'
            }
            case 'numberOfChildren': {
                return 'Number of Children'
            }
            case 'experience': {
                return 'Experience'
            }
            case 'targetedNextRole': {
                return 'Targeted Next Role'
            }
            case 'targetedNextOrganization': {
                return 'Targeted Next Organization'
            }
            case 'careerObjectives': {
                return 'Career Objectives'
            }
            case 'contractTitle': {
                return 'Contract Title'
            }
            case 'solisCode': {
                return 'Solis Code'
            }
            case 'legalEntity': {
                return 'Legal Entity'
            }
            case 'displayId': {
                return 'ID'
            }
            case 'localContractTitle': {
                return 'Local Contract Title'
            }
            case 'originLegalEntity': {
                return 'OriginLegal Entity'
            }
            case 'fullTimeEquivalent': {
                return 'Full Time Equivalent'
            }
            case 'contractStartDate': {
                return 'Contract Start Date'
            }
            case 'activeStatus': {
                return 'Active Status'
            }
            case 'contractStatus': {
                return 'Contract Status'
            }
            case 'contractSubStatus': {
                return 'Contract Sub Status'
            }
            case 'localStaff': {
                return 'Local Staff'
            }
            case 'expatStatus': {
                return 'Expat Status'
            }
            case 'lastWorkingDay': {
                return 'Last Working Day'
            }
            case 'endOfContractReason': {
                return 'End of Contract Reason'
            }
            case 'endOfContractComments': {
                return 'End of Contract Comments'
            }
            case 'taxAddress': {
                return 'Tax Address'
            }
            case 'zip': {
                return 'Zip'
            }
            case 'state': {
                return 'State'
            }
            case 'taxAddress': {
                return 'Tax Address'
            }
            case 'country': {
                return 'Country'
            }
            case 'referenceCity': {
                return 'Reference City'
            }
            case 'trainings': {
                return 'Trainings'
            }
            case cardName: {
                return cardName ? cardName : '';
            }
        }
    }

    // ------------------------------
    addressInput(address: any) {
        if (address.field === 'taxAddress') {
            // this.associate.personalContactDetails.personalAddress = Object.assign({}, address.address );
            this.personalContactDetails.taxAddress.address1 = address.address.address1;
            this.personalContactDetails.taxAddress.address2 = address.address.address2;
            this.personalContactDetails.taxAddress.address3 = address.address.address3;
            this.personalContactDetails.taxAddress.city = address.address.city;
            this.personalContactDetails.taxAddress.zip = address.address.zip;
            this.personalContactDetails.taxAddress.state = address.address.state;
            this.personalContactDetails.taxAddress.country = address.address.country;
            for (let adf in this.associate.personalContactDetails.taxAddress) {
                if (this.associate.personalContactDetails.taxAddress.hasOwnProperty(adf)) {
                    if (this.associate.personalContactDetails.taxAddress[adf] == undefined) {
                        this.associate.personalContactDetails.taxAddress[adf] = '';
                    }
                }
            }
        }
        if (address.field === 'personalAddress') {
            // this.associate.personalContactDetails.taxAddress = Object.assign({}, address.address );
            this.personalContactDetails.personalAddress.address1 = address.address.address1;
            this.personalContactDetails.personalAddress.address2 = address.address.address2;
            this.personalContactDetails.personalAddress.address3 = address.address.address3;
            this.personalContactDetails.personalAddress.city = address.address.city;
            this.personalContactDetails.personalAddress.zip = address.address.zip;
            this.personalContactDetails.personalAddress.state = address.address.state;
            this.personalContactDetails.personalAddress.country = address.address.country;
            for (let adf in this.associate.personalContactDetails.personalAddress) {
                if (this.associate.personalContactDetails.personalAddress.hasOwnProperty(adf)) {
                    if (this.associate.personalContactDetails.personalAddress[adf] == undefined) {
                        this.associate.personalContactDetails.personalAddress[adf] = '';
                    }
                }
            }
        }
    }

    workCountryChange() {
        this.personalContactDetails.personalAddress.address1 = '';
        this.personalContactDetails.personalAddress.address2 = '';
        this.personalContactDetails.personalAddress.address3 = '';
        this.personalContactDetails.personalAddress.city = '';
        this.personalContactDetails.personalAddress.zip = '';
        this.personalContactDetails.personalAddress.state = '';
        this.personalContactDetails.personalAddress.country = '';

        this.personalContactDetails.taxAddress.address1 = '';
        this.personalContactDetails.taxAddress.address2 = '';
        this.personalContactDetails.taxAddress.address3 = '';
        this.personalContactDetails.taxAddress.city = '';
        this.personalContactDetails.taxAddress.zip = '';
        this.personalContactDetails.taxAddress.state = '';
        this.personalContactDetails.taxAddress.country = '';
    }

    hyperLinkRoute(page, id) {
        if (page === 'Site') {
            this.router.navigate([`home/organization/site-profile/view/${id}`]);
        }
        if (page === 'Company') {
            this.router.navigate([`home/organization/profile/view/${id}`]);
        }
        if (page === 'Legal Entity') {
            this.router.navigate([`home/legal-entity/update-legal-entity/${id}`]);
        }
    }

    removePdfFile(arrayName: string, index) {
        if (arrayName === 'workExperience') {
            this.workExperience.experience[index].originalDocumentName = '';
            this.workExperience.experience[index].experienceLetter = '';
        } if (arrayName === 'formalEducation') {
            this.qualificationsAndTrainings.formalEducation[index].originalDocumentName = '';
            this.qualificationsAndTrainings.formalEducation[index].schoolDocument = '';
        } if (arrayName === 'trainings') {
            this.trainings.trainings[index].originalDocumentName = '';
            this.trainings.trainings[index].trainingDocument = ''
        }

    }

    starJobWorkExperience(index) {
        if (this.workExperience['experience'][index].isStarredJob === true) {
            this.workExperience['experience'][index].isStarredJob = false;
            this.associate.workExperience['experience'][index].isStarredJob = false;
            this.update('none');
        } else if (this.workExperience['experience'][index].isStarredJob !== true) {
            if ((this.numberOfStarredWorkExperiences()) < 5) {
                this.workExperience['experience'][index].isStarredJob = true;
                this.associate.workExperience['experience'][index].isStarredJob = true;
                this.update('none');
            } else {
                this.toastService.error('only 5 work experiences can be starred');
            }
        }
    }

    numberOfStarredWorkExperiences() {
        let counter = 0;
        if (this.workExperienceEdit === true) {
            for (let i = 0; i < this.workExperience['experience'].length; i++) {
                if (this.workExperience['experience'][i] && this.associate.workExperience['experience'][i].isStarredJob && this.workExperience['experience'][i].isStarredJob === true) {
                    counter = counter + 1;
                }
            }
            return counter;
        } else {
            for (let i = 0; i < this.associate.workExperience['experience'].length; i++) {
                if (this.workExperience['experience'][i] && this.associate.workExperience['experience'][i].isStarredJob && this.associate.workExperience['experience'][i].isStarredJob === true) {
                    counter = counter + 1;
                }
            }
            return counter;
        }
    }

    sortData(sort: Sort, field: string) {
        let data = Object.assign([], this.associate[field]);
        if (!sort.active || sort.direction === '') {
            return;
        }
        let isAsc = sort.direction === 'asc';
        let sortedList = data.sort((a, b) => {
            return this.compare(a[sort.active].toLowerCase(), b[sort.active].toLowerCase(), isAsc);
        });
        this.associate[field] = sortedList;
    }

    compare(a, b, isAsc) {
        return (a < b ? -1 : 1) * (isAsc ? 1 : -1);
    }

    routeLinkAlternative(routePathArray) {
        this.router.navigate(routePathArray);
    }

    changeHeirarchyMode() {
        this.managementHeirarchyisGraphicalOrTabular = (this.managementHeirarchyisGraphicalOrTabular === 'tabular') ? 'graphical' : 'tabular';
    }

    getGroupJoinMinDate() {
        let tempDate = new Date(this.associate.personalInformation.dateOfBirth);
        tempDate = new Date(tempDate.setFullYear(tempDate.getFullYear() + 14));
        return tempDate;
    }

    emptyLanguageLevel(language, event) {
        if (this.languages[language].name === 'None') {
            this.languages[language].level = '';
        }
    }

    ongoingWorkExperienceChange(index, ongGoing) {
        if (ongGoing === true) {
            this.workExperience.experience[index].duration = "";
        }
    }


    removeOwnTraining(index: Number) {
        this.trainings.ownTraining.splice(index, 1);
    }

    getAssociateStatusInTraining(training) {
        const index = training.associateIds.map(function (e) { return e.id; }).indexOf(this.currentUser.associateId);
        if (index !== -1) {
            return training.associateIds[index]['status'];
        } else {
            return 'Not Started'
        }
    }

    compareJson(obj1: JSON, obj2: JSON) {
        const keys = Object.keys(obj1);
        if (!obj1 || !obj2) {
            return false;
        }
        for (let i = 0; i < keys.length; i++) {
            if (isDate(obj1[keys[i]])) {
                const diff = moment(obj1[keys[i]]).startOf('day').diff(moment(obj2[keys[i]]).startOf('day'), 'days')
                if (diff === 0) continue;
                return false;
            }
            else if (obj1[keys[i]] != obj2[keys[i]]) {
                return false;
            }
        }
        return true;
    }

    isOwnTrainingValidated() {
        if (this.validatedQualificationsAndTrainings.ownTraining === undefined && this.trainings.ownTraining !== undefined) {
            return false;
        }
        else if (this.trainings.ownTraining.length !== this.validatedQualificationsAndTrainings.ownTraining.length) {
            return false;
        } else {
            const length = this.trainings.ownTraining.length;
            for (let i = 0; i < length; i++) {
                if (this.compareJson(this.trainings.ownTraining[i], this.validatedQualificationsAndTrainings.ownTraining[i])) {
                    continue;
                } else {
                    return false;
                }
            }
            return true;
        }
    }

    isSonacadmyTrainingValidated() {
        if (this.validatedQualificationsAndTrainings.trainings === undefined) {
            return false;
        }
        else if (this.trainings.trainings.length !== this.validatedQualificationsAndTrainings.trainings.length) {
            return false;
        } else {
            const length = this.trainings.trainings.length;
            for (let i = 0; i < length; i++) {
                if (this.validatedQualificationsAndTrainings.trainings.indexOf(this.trainings.trainings[i]) !== -1) {
                    continue;
                } else {
                    return false;
                }
            }
            return true;
        }
    }


    getTrainings() {
        this.trainingService.getAllCourses({ '_id': this.trainings.trainings }, { name: 1 }, 0, 50000)
            .subscribe(data => {
                this.trainingsData = data['data'];
            })
    }

    isValidatedOwnTrining(tr, index) {

        if (this.validatedQualificationsAndTrainings === undefined) {
            return false;
        } else if (this.validatedQualificationsAndTrainings.ownTraining === undefined) {
            return false;
        } else if (index >= this.validatedQualificationsAndTrainings.ownTraining.length) {
            return false;
        } else {
            return this.compareJson(tr, this.validatedQualificationsAndTrainings.ownTraining[index]);
        }
    }

    isRemovedOwnTraining(tr, index) {

        if (this.qualificationsAndTrainings === undefined) {
            return false;
        } else if (this.trainings.ownTraining === undefined) {
            return false;
        } else if (index >= this.trainings.ownTraining.length) {
            return false;
        } else {
            return this.compareJson(tr, this.trainings.ownTraining[index]);
        }

    }


    removeAvatar() {
        this.tempBase64Img = undefined;
        if (this['personalInformation'].gender.includes('Female')) {
            this['personalInformation'].avatarUrl = 'uploads/assets/img/profile/Female-orange.png';
        } else {
            this['personalInformation'].avatarUrl = 'uploads/assets/img/profile/Male-orange.png';
        }
    }

    triggerManagerChangeObservable(fieldName) {
        if (fieldName === 'hrManager') {
            this.hrManagerSearchBeh.next(this.jobDescription.hrManager.name);
        } if (fieldName === 'manager') {
            this.lineManagerSearchBeh.next(this.jobDescription.manager.name);
        } if (fieldName === 'functionalManager') {
            this.functionalManagerSearchBeh.next(this.jobDescription.functionalManager.name);
        }
    }

}


@Component({
    selector: 'app-image-crop-dialog',
    template: `<div class="width: 100%;">
    <div class="col-xs-12 fl-n xs-pl-0"><h2 class="xs-m-0 xs-pb-10" >Image Adjustment</h2></div>
  <div class="col-xs-12 xs-pt-4 xs-pb-4 blue_bar alert alert-info fl-n" translate>
  Recommended image resolution is <span class="fw-bold">236x272</span></div>
  <div style="width: 100%;height: 100%" class="pull-left xs-pb-15 xs-pt-15">
                    <div id="imageToCropDiv">
                        <img [ngClass]="{'hidden': imageHidden}" id="imageToCrop" src="{{imageChangedEvent}}"/>
                    </div>
                </div>
                <div class="md-mt-10">
              <button type="button" (click)="onSaveClick()" class="pull-right btn btn-primary xs-ml-5" translate>Save</button>
              <button type="button" class="pull-right btn btn-primary cancel_btn" (click)="cancel()" translate>Cancel</button>
              </div>`,
    styleUrls: ['./profile.component.scss'],
})
export class ImageCropDialogComponent {
    imageChangedEvent: any = '';
    croppedImage: any = '';
    croppy: any;
    imageHidden = true;
    constructor(
        public dialogRef: MatDialogRef<ProfileComponent>,
        @Inject(MAT_DIALOG_DATA) public data: any) {
        this.imageChangedEvent = data.event;
        setTimeout(() => {
            this.imageHidden = false;
            this.croppy = new Croppie(document.getElementById('imageToCrop'), {
                enableExif: true,
                viewport: {
                    width: 236,
                    height: 272
                },
                boundary: {
                    width: 450,
                    height: 372
                },
                enableOrientation: true,
                enforceBoundary: true
            });
        }, 250);
    }

    onSaveClick(): void {
        this.croppy.result().then(result => {
            this.dialogRef.close(result);
        });
    }

    fileChangeEvent(event: any): void {
        this.imageChangedEvent = event;
    }

    imageCropped(image: string) {
        this.croppedImage = image;
    }
    cancel() {
        this.dialogRef.close();
    }

}

